<template>
    <div class="main homepage-layout pb-8">
        <div class="container">
            <h1> Accessibility </h1>
            <h3> Enable Scroll Bars</h3>
            <button type="button" class="btn btn--primary btn--half" @click="toggleScrollbar()"> {{ !scrollbarEnabled ? 'Enable' : 'Disable' }} </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Accessibility',
    computed: {
        ...mapGetters({
            scrollbarEnabled: 'account/getScrollbarEnabled',
        }),
    },
    methods: {
        toggleScrollbar() {
            if (!this.scrollbarEnabled) {
                this.$store.commit('account/setScrollbarEnabled', true);
            } else {
                this.$store.commit('account/setScrollbarEnabled', false);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .container {
        padding: 20px;
        margin: 0 auto;
        text-align: center;
    }
</style>
